import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Modal } from 'semantic-ui-react';

import { AppState } from 'services/types';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';
import RoleGate from '../RoleGate';

// Actions
import { updateQueryString } from '../../services/router/actions';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from '../../workspaces/redux-error-boundary';
import {
    makeSelectQueryStringValue,
    makeSelectQueryStringNumberValue
} from '../../workspaces/react-router-selectors';

// Components
// @ts-ignore
import ErrorBoundaryAlert from '../ErrorBoundaryAlert';
import ForecastForm from './components/ForecastForm';

interface DispatchProps {
    updateQueryString: Function;
}

interface ConnectedProps {
    forecastModal?: 'created' | 'updated' | 'edit';
    selectedQuantityForecast?: number;
}

type Props = ConnectedProps & DispatchProps;

export class ForecastDialog extends React.PureComponent<Props> {
    get open(): boolean {
        const { forecastModal, selectedQuantityForecast } = this.props;

        return !!forecastModal && !!selectedQuantityForecast;
    }

    handleClose = (): void => {
        this.props.updateQueryString({
            forecastModal: undefined,
            selectedEntity: undefined
        });
    };

    render(): React.ReactElement | null {
        const { selectedQuantityForecast } = this.props;

        return (
            <RoleGate requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}>
                <Modal
                    open={this.open}
                    onClose={this.handleClose}
                    size="fullscreen"
                    centered={false}
                    closeIcon
                >
                    <ErrorBoundary
                        namespace="ForecastDialog"
                        FallbackComponent={<ErrorBoundaryAlert />}
                    >
                        <ForecastForm
                            quantityForecastId={selectedQuantityForecast}
                            onClose={this.handleClose}
                        />
                    </ErrorBoundary>
                </Modal>
            </RoleGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    forecastModal: makeSelectQueryStringValue('forecastModal'),
    selectedQuantityForecast: makeSelectQueryStringNumberValue('selectedEntity')
});

export default connect(mapStateToProps, { updateQueryString })(ForecastDialog);
